import { render, staticRenderFns } from "./ExpedienteHeader.vue?vue&type=template&id=53caab38&scoped=true&"
import script from "./ExpedienteHeader.vue?vue&type=script&lang=js&"
export * from "./ExpedienteHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteHeader.vue?vue&type=style&index=0&id=53caab38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53caab38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VImg,
})
